<div class="room-event-container">

    <div class="cave-background-container">
        <img class="cave-background-image" src="{{ this.RoomEventService.roomBackground }}" />
    </div>

    <!-- dev info -->
    <div class="dev-info" *ngIf="DungeonPathService.showDevInfo === true">
        {{this.RoomEventService.roomType}} <br>
        currentLevel = {{this.RoomEventService.currentLevel}} <br>
        currentRoom = {{this.RoomEventService.currentRoom}}
    </div>

    <!-- HEADER -->
    <!-- TURN INFO -->
    <div class="stat-row">

        <div class="stat-row-spacer">
        </div>

        <div class="stat-container">
            <p *ngIf="this.RoomEventService.isPlayerTurn === true 
            && this.RoomEventService.roomType != 'treasure' 
            && this.RoomEventService.roomType != 'fire'" class="stat-text"> Player Turn </p>
        </div>

        <div class="stat-container">
            <p *ngIf="this.RoomEventService.isPlayerTurn === false && this.RoomEventService.monsterHealthValue > 0 
                && this.RoomEventService.roomType != 'treasure' && this.RoomEventService.roomType != 'fire'"
                class="stat-text"> Monster Turn </p>
        </div>

    </div>

    <!-- BODY -->
    <div class="flexrow">

        <!-- Equipment Column -->
        <div class="equip-column">

            <!-- helm -->
            <div class="equip-slot"
                [style.background-color]="this.PlayerInventoryService.getItemColour(this.PlayerInventoryService.helm.itemTier)">
                <img class="item-image" src="assets/images/equipment/{{this.PlayerInventoryService.helm.itemName}}.png">
            </div>
            <div class="tooltip">
                <div class="tooltipArrow"></div>
                <a class="tooltipTitle">{{this.PlayerInventoryService.helm.itemName}}<br></a>
                <a class="tooltipText">Defence Value: {{this.PlayerInventoryService.helm.itemDefenceValue}}<br></a>
                <a class="tooltipDesc">"{{this.PlayerInventoryService.helm.itemDescription}}"</a>
            </div>

            <!-- armour -->
            <div class="equip-slot"
                [style.background-color]="this.PlayerInventoryService.getItemColour(this.PlayerInventoryService.armour.itemTier)">
                <img class="item-image"
                    src="assets/images/equipment/{{this.PlayerInventoryService.armour.itemName}}.png">
            </div>
            <div class="tooltip">
                <div class="tooltipArrow"></div>
                <a class="tooltipTitle">{{this.PlayerInventoryService.armour.itemName}}<br></a>
                <a class="tooltipText">Defence Value: {{this.PlayerInventoryService.armour.itemDefenceValue}}<br></a>
                <a class="tooltipDesc">"{{this.PlayerInventoryService.armour.itemDescription}}"</a>
            </div>

            <!-- offhand -->
            <div class="equip-slot"
                [style.background-color]="this.PlayerInventoryService.getItemColour(this.PlayerInventoryService.offhand.itemTier)">
                <img class="item-image"
                    src="assets/images/equipment/{{this.PlayerInventoryService.offhand.itemName}}.png">
                <button class="equip-button" (click)="Offhand()" *ngIf="this.RoomEventService.isPlayerTurn === true 
                && this.PlayerInventoryService.offhand.itemTier < 4 && this.RoomEventService.isPlayerActionSubmitted === false">
                </button>
            </div>
            <div class="tooltip">
                <div class="tooltipArrow"></div>
                <a class="tooltipTitle">{{this.PlayerInventoryService.offhand.itemName}}<br></a>
                <a *ngIf="this.PlayerInventoryService.offhand.itemAttackValue > 0" class="tooltipText">Attack Value:
                    {{this.PlayerInventoryService.offhand.itemAttackValue}}<br></a>
                <a *ngIf="this.PlayerInventoryService.offhand.itemDefenceValue > 0" class="tooltipText">Defence Value:
                    {{this.PlayerInventoryService.offhand.itemDefenceValue}}<br></a>
                <a class="tooltipDesc">"{{this.PlayerInventoryService.offhand.itemDescription}}"</a>
            </div>

            <!-- weapon -->
            <div class="equip-slot"
                [style.background-color]="this.PlayerInventoryService.getItemColour(this.PlayerInventoryService.weapon.itemTier)">
                <img class="item-image"
                    src="assets/images/equipment/{{this.PlayerInventoryService.weapon.itemName}}.png">
                <button class="equip-button" (click)="Attack()" *ngIf="this.RoomEventService.isPlayerTurn === true && this.RoomEventService.isPlayerActionSubmitted === false">
                </button>
            </div>
            <div class="tooltip">
                <div class="tooltipArrow"></div>
                <a class="tooltipTitle">{{this.PlayerInventoryService.weapon.itemName}}<br></a>
                <a class="tooltipText">Attack Value: {{this.PlayerInventoryService.weapon.itemAttackValue}}<br></a>
                <a class="tooltipDesc">"{{this.PlayerInventoryService.weapon.itemDescription}}"</a>
            </div>

        </div>

        <!-- Player Avatar Column -->
        <div class="avatar-column">

            <div class="status-box">
                <div *ngIf="this.RoomEventService.isPlayerBlocking === true"> Blocking <br> </div>
                <div *ngIf="this.RoomEventService.isAttackAvoided === true"> Avoided Attack </div>
                <div *ngIf="this.RoomEventService.roomType === 'fire'"> Resting </div>
            </div>

            <div
                *ngIf="this.PlayerInventoryService.playerHealth <= 0 && this.PlayerInventoryService.isGodmodeOn === false">
                <img class="player-dead" src="{{ this.PlayerInventoryService.playerAvatar }}" />
            </div>

            <div *ngIf="this.PlayerInventoryService.playerHealth > 0 || this.PlayerInventoryService.isGodmodeOn === true"
                id="playerAvatar" class="avatar">

                <div class="equip-in-use"></div>

                <img class="avatar-attacking" *ngIf="this.RoomEventService.isPlayerAttacking === true"
                    src="{{ this.PlayerInventoryService.playerAvatar }}" />

                <img class="avatar" *ngIf="this.RoomEventService.isPlayerAttacking === false &&
                this.RoomEventService.isAttackAvoided === false"
                    src="{{ this.PlayerInventoryService.playerAvatar }}" />

                <img class="avatar-avoiding" *ngIf="this.RoomEventService.isPlayerAttacking === false &&
                    this.RoomEventService.isAttackAvoided === true"
                    src="{{ this.PlayerInventoryService.playerAvatar }}" />

                <div>
                    <img *ngIf="this.RoomEventService.isPlayerBlocking === true && 
                                this.RoomEventService.isPlayerAttacking === false" class="eqiup-blocking"
                        src="assets/images/equipment/{{this.PlayerInventoryService.offhand.itemName}}.png">
                    <img *ngIf="this.RoomEventService.isPlayerAttacking === true &&
                        this.PlayerInventoryService.weapon.itemTier < 3" class="eqiup-attacking"
                        src="assets/images/equipment/{{this.PlayerInventoryService.weapon.itemName}}.png">
                    <img *ngIf="this.RoomEventService.isPlayerAttacking === true &&
                        this.PlayerInventoryService.weapon.itemTier >= 3" class="eqiup-attacking-2"
                        src="assets/images/equipment/{{this.PlayerInventoryService.weapon.itemName}}.png">
                    <img *ngIf="this.RoomEventService.isDamageNegated === true" class="damage-deflect"
                        src="assets/images/effects/Block Effect.png">
                    <img *ngIf="this.RoomEventService.isPlayerTakeDamage === true" class="damage-hit"
                        src="assets/images/effects/Hit Effect.png">
                    <img *ngIf="this.RoomEventService.isHandgunInUse === true" class="eqiup-handgun"
                        src="assets/images/equipment/{{this.PlayerInventoryService.offhand.itemName}}.png">
                </div>

            </div>

        </div>

        <!-- Room Event Column -->
        <!-- MONSTER -->
        <div *ngIf="this.RoomEventService.roomType === 'monster' ||
             this.RoomEventService.roomType === 'boss' ||
              this.RoomEventService.roomType === 'finalboss'">

            <div *ngIf="this.RoomEventService.monsterHealthValue > 0" class="avatar-column">
                <div class="status-box">
                    <div
                        *ngIf="this.RoomEventService.isMonsterStunned === true && this.RoomEventService.monsterHealthValue > 0">
                        Stunned </div>
                </div>

                <div class="monster">
                    <img class="monster" *ngIf="this.RoomEventService.isMonsterAttacking === false"
                        src="{{ this.RoomEventService.roomImage }}" />
                    <img class="monster-attacking" *ngIf="this.RoomEventService.isMonsterAttacking === true"
                        src="{{ this.RoomEventService.roomImage }}" />
                    <img class="monster-claw-attacking" *ngIf="this.RoomEventService.isMonsterAttacking === true"
                        src="assets/images/effects/Monster Claw.png" />
                </div>

            </div>

            <!-- monster hit effect persists outside of monsters life -->
            <img *ngIf="this.RoomEventService.isMonsterTakeDamage === true && 
            this.PlayerInventoryService.weapon.itemName != 'Lightsaber'" class="monster-damage-hit"
                src="assets/images/effects/Monster Hit Effect.png">
            <img *ngIf="this.RoomEventService.isMonsterTakeDamage === true && 
            this.PlayerInventoryService.weapon.itemName === 'Lightsaber' &&
            this.RoomEventService.isPlayerTurn === true" class="monster-lightsaber-hit"
                src="assets/images/effects/Lightsaber Effect.png">

            <!-- monster loot -->
            <div class="avatar-column">
                <div
                    *ngIf="this.RoomEventService.monsterHealthValue <= 0 && this.RoomEventService.isLootTaken === false && this.RoomEventService.roomType != 'finalboss'">

                    <div class="loot-container">

                        <div class="flexrow">
                            <div *ngFor="let loot of this.RoomEventService.roomLootList">
                                <div class="loot-card"
                                    [style.background-color]="this.PlayerInventoryService.getItemColour(loot.itemTier)"
                                    (click)="takeLoot(loot.itemName)">
                                    <img class="loot-image" src="assets/images/equipment/{{loot.itemName}}.png">
                                    <a class="tooltipTitle">{{loot.itemName}}<br></a>
                                    <div *ngIf="loot.itemName === 'Torch'"
                                        class="specialDiv"><br></div>
                                    <a *ngIf="loot.itemAttackValue > 0" class="tooltipText">Attack Value:
                                        {{loot.itemAttackValue}}<br></a>
                                    <a *ngIf="loot.itemType === 'armour' || loot.itemType === 'helm' || loot.itemName === 'Wooden Buckler' || 
                                    loot.itemName === 'Tower Shield'" class="tooltipText">Defence Value:
                                        {{loot.itemDefenceValue}}<br></a>
                                    <a *ngIf="loot.itemType === 'food'" class="tooltipText">Heals 1 Health<br></a>
                                    <a class="tooltipDesc">"{{loot.itemDescription}}"</a>
                                </div>
                                <div *ngIf="loot.itemType != 'food'" class="loot-card-tooltip">
                                    <a>Replace<br></a>
                                    <div class="specialDiv"></div>
                                    <a *ngIf="loot.itemType === 'helm'"
                                        class="tooltipTitle">{{this.PlayerInventoryService.helm.itemName}}<br></a>
                                    <a *ngIf="loot.itemType === 'armour'"
                                        class="tooltipTitle">{{this.PlayerInventoryService.armour.itemName}}<br></a>
                                    <a *ngIf="loot.itemType === 'offhand'"
                                        class="tooltipTitle">{{this.PlayerInventoryService.offhand.itemName}}<br></a>
                                    <a *ngIf="loot.itemType === 'weapon'"
                                        class="tooltipTitle">{{this.PlayerInventoryService.weapon.itemName}}<br></a>
                                </div>
                            </div>
                        </div>

                        <div class="flexrow">
                            <div class="forgo-loot-button" (click)="this.DungeonPathService.toggleDungeonPath()">
                                take nothing and leave
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div *ngIf="this.RoomEventService.monsterHealthValue <= 0">
                <img class="monster-dead" src="{{ this.RoomEventService.roomImage }}" />
            </div>

        </div>



        <!-- TREASURE -->
        <div *ngIf="this.RoomEventService.roomType === 'treasure'">

            <!-- loot -->
            <div class="avatar-column">

                <div class="loot-container" *ngIf="this.RoomEventService.isLootTaken === false">

                    <div class="flexrow">
                        <div *ngFor="let loot of this.RoomEventService.roomLootList">
                            <div class="loot-card"
                                [style.background-color]="this.PlayerInventoryService.getItemColour(loot.itemTier)"
                                (click)="takeLoot(loot.itemName)">
                                <img class="loot-image" src="assets/images/equipment/{{loot.itemName}}.png">
                                <a class="tooltipTitle">{{loot.itemName}}<br></a>
                                <div *ngIf="loot.itemName === 'Torch'"
                                    class="specialDiv"><br></div>
                                <a *ngIf="loot.itemAttackValue > 0" class="tooltipText">Attack Value:
                                    {{loot.itemAttackValue}}<br></a>
                                <a *ngIf="loot.itemType === 'armour' || loot.itemType === 'helm' || loot.itemName === 'Wooden Buckler' || 
                                    loot.itemName === 'Tower Shield'" class="tooltipText">Defence Value:
                                    {{loot.itemDefenceValue}}<br></a>
                                <a *ngIf="loot.itemType === 'food'" class="tooltipText">Heals 1 Health<br></a>
                                <a class="tooltipDesc">"{{loot.itemDescription}}"</a>
                            </div>
                            <div *ngIf="loot.itemType != 'food'" class="loot-card-tooltip">
                                <a>Replace<br></a>
                                <div class="specialDiv"></div>
                                <a *ngIf="loot.itemType === 'helm'"
                                    class="tooltipTitle">{{this.PlayerInventoryService.helm.itemName}}<br></a>
                                <a *ngIf="loot.itemType === 'armour'"
                                    class="tooltipTitle">{{this.PlayerInventoryService.armour.itemName}}<br></a>
                                <a *ngIf="loot.itemType === 'offhand'"
                                    class="tooltipTitle">{{this.PlayerInventoryService.offhand.itemName}}<br></a>
                                <a *ngIf="loot.itemType === 'weapon'"
                                    class="tooltipTitle">{{this.PlayerInventoryService.weapon.itemName}}<br></a>
                            </div>
                        </div>
                    </div>

                    <div class="flexrow">
                        <div class="forgo-loot-button" (click)="this.DungeonPathService.toggleDungeonPath()">
                            take nothing and leave
                        </div>
                    </div>

                </div>
            </div>

            <!-- chest image -->
            <div class="flexrow">
                <div *ngIf="this.RoomEventService.roomType === 'treasure'">
                    <img id="treasure" class="chest" src="assets/images/misc/ChestClosed.png">
                </div>
            </div>

        </div>

        <!-- FIRE -->
        <div class="avatar-column" *ngIf="this.RoomEventService.roomType === 'fire'">
            <div class="status-box"> </div>
            <img class="fire" src="assets/images/misc/Fire.png">
        </div>

    </div>

    <!----------------------------------------- FOOTER --------------------------------------------->

    <div class="stat-row">

        <div class="stat-row-spacer">
        </div>

        <!-- player stats -->
        <div class="stat-container">
            <div class="stat-box">
                <span class="stat-text"> {{this.PlayerInventoryService.weapon.itemAttackValue}}</span>
                <span class="iconify" color="grey" data-icon="mdi:sword" data-inline="false"></span>
            </div>

            <div class="stat-box">
                <span *ngIf="this.RoomEventService.isPlayerBlocking === true" class="stat-text-green"> {{
                    this.PlayerInventoryService.playerDefence }}</span>
                <span *ngIf="this.RoomEventService.isPlayerBlocking === false" class="stat-text"> {{
                    this.PlayerInventoryService.playerDefence }}</span>
                <span class="iconify" color="grey" data-icon="bx-bxs-shield" data-inline="false"></span>
            </div>

            <div class="stat-box">
                <span class="iconify" color="red" data-icon="ant-design:heart-filled" data-inline="false"></span>
                <span class="stat-text"> {{ this.PlayerInventoryService.playerHealth }}</span>
                <div *ngIf="this.RoomEventService.healthChangeValue > 0" class="health-pos">
                    +{{ this.RoomEventService.healthChangeValue }}
                </div>
                <div *ngIf="this.RoomEventService.healthChangeValue < 0" class="health-neg">
                    {{ this.RoomEventService.healthChangeValue }}
                </div>
            </div>

        </div>

        <!-- monster  stats -->
        <div class="stat-container">
            <div *ngIf="this.RoomEventService.monsterHealthValue > 0" class="stat-box">
                <span class="iconify" color="grey" data-icon="mdi:sword" data-inline="false"></span>
                <span class="stat-text"> {{this.RoomEventService.monsterAttackValue}}</span>
            </div>
            <div class="stat-box">
            </div>
            <div *ngIf="this.RoomEventService.monsterHealthValue > 0" class="stat-box">
                <div class="stat-box">
                    <span class="iconify" color="red" data-icon="ant-design:heart-filled" data-inline="false"></span>
                    <span class="stat-text"> {{this.RoomEventService.monsterHealthValue}}</span>
                    <div *ngIf="this.RoomEventService.isMonsterTakeDamage === true 
                    && this.RoomEventService.isHandgunInUse === false" class="health-neg">
                        -{{ this.RoomEventService.monsterHealthChangeValue }}
                    </div>
                    <div *ngIf="this.RoomEventService.isMonsterTakeDamage === true 
                    && this.RoomEventService.isHandgunInUse === true" class="health-neg">
                        -1
                    </div>
                </div>
            </div>

        </div>

    </div>

    <!-- START -->
    <div *ngIf="this.RoomEventService.roomType === 'start'">
        <div>

        </div>
    </div>

    <!-- <div *ngIf="this.RoomEventService.roomType === 'treasure' || this.RoomEventService.roomType === 'fire'">
        <this div replaces the stat boxes for spacing -->
    <!-- </div> -->

</div>